import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensUserForm from './Form/ScreensUserForm';
import ScreensUsersList from './List/ScreensUsersList';

function ScreensUsers() {
  return (
    <Routes>
      <Route
        path="/list"
        element={
          <RoutePrivate
            element={ScreensUsersList}
            requiredPermission="users.update"
          />
        }
      />
      <Route
        path="/create"
        element={
          <RoutePrivate
            element={ScreensUserForm}
            requiredPermission="users.update"
          />
        }
      />
      <Route
        path="/:id"
        element={
          <RoutePrivate
            element={ScreensUserForm}
            requiredPermission="users.update"
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/users/list" />} />
    </Routes>
  );
}

export default ScreensUsers;
